import React, { useEffect, useState } from "react";
import { get, forEach, includes, isEmpty } from "lodash";
import { Radio, Empty, Spin } from "antd";

// include local dependencies
import "./dashboardNavigation.scss";
import DashboardService from "@services/dashboard.service";
import { usePopulationInsightStore } from "@stores/populationInsightStore";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import List from "./listView";
import Card from "./cardView";
import { LeftNav } from "./leftnav";
import { useDashboardStore } from "@stores/dashboardStore";
import { useHighCostPatientStore } from "@stores/highCostPatientStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useGenericTableStore } from "@stores/useGenericTableStore";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import DataNotFound from "@components/noDataFound";
import { useMeasuresStore } from "@stores/measuresStore";
import { useDynamicFormStore } from "@stores/dynamicFormStore";
import { useDataQualityReportStore } from "@stores/dataQualityReport";
import { useChronicBreakdownStore } from "@stores/chronicBreakdownStore";

// header Nav Bar
const DashboardNavigation = (props: { handleReportClick: (arg0: any) => void; handleOpenFlagOfLeftNav: () => void; updateReport: any }) => {
  const [isLoading, setLoading] = useState(false);
  const setResponse = useDashboardStore((state) => state.setResponse);
  const setSelectedLob = useDashboardStore((state) => state.setSelectedLob);
  const selectedNavigation = useDashboardStore((state) => state.selectedNavigation);
  const setSelectedNavigation = useDashboardStore((state) => state.setSelectedNavigation);
  const reportList = useDashboardStore((state) => state.reportList);
  const setReportList = useDashboardStore((state) => state.setReportList);
  const view = useDashboardStore((state) => state.view);
  const setView = useDashboardStore((state) => state.setView);
  const searchedKeyWord = useDashboardStore((state) => state.searchedKeyWord);
  const selectedLob = useDashboardStore((state) => state.selectedLob);
  const setSelectedReport = useDashboardStore((state) => state.setSelectedReport);
  const isBackButtonDisplay = useHospitalMappingStore((state) => state.isBackButtonDisplay);

  const viewTypeOptions = [
    { label: <i className="icon-list" />, value: "list" },
    { label: <i className="icon-grid" />, value: "card" },
  ];

  useEffect(() => {
    console.log("DashboardNavigation.initial use effect");
    if (isEmpty(selectedLob)) {
      setLoading(true);
      DashboardService.fetchHeaderOptions().subscribe({
        next: (response: any) => {
          const _response = get(response, "data.data", []);
          setResponse(_response);
          
          forEach(_response, (item: any) => {
            forEach(item.options, (option) => {
              forEach(option.groups, (group) => {
                forEach(get(group, "options", []), (_option) => {
                  if (_option.value === "cmContactMatrix" && isBackButtonDisplay) {
                    setSelectedLob(item);
                    setSelectedNavigation(group);
                    setReportList(group?.options);
                    setSelectedReport(_option);
                  } else if (get(_option, "default", "N") === "Y") {
                    setSelectedLob(item);
                    setSelectedNavigation(group);
                    setReportList(group?.options);
                  }
                });
              });
            });
          });

          setLoading(false);
        },
        error: (e) => {
          console.log(e);
          setLoading(false);
        },
      });
    }
  }, [isBackButtonDisplay, selectedLob, setReportList, setResponse, setSelectedLob, setSelectedNavigation, setSelectedReport]);

  const reportListComponent = () => {
    const result: JSX.Element[] = [];

    forEach(
      // sorting the report list each and every time when recently opened is selected
      // if you are in other places then sort the report list based on displayOrder, which is configured in DB
      selectedNavigation?.groupTitle === "Recently Opened" ? 
      reportList.sort((a: any, b: any) => new Date(b.lastOpenDate)?.getTime() - new Date(a.lastOpenDate)?.getTime()) : 
      reportList.sort((a: any, b: any) => a.displayOrder - b.displayOrder),
      (report: any) => {
        // if search is active, then showing only those reports which contains the keyword that has been searched
        if ((!isEmpty(searchedKeyWord) && includes(report.title?.toLowerCase(), searchedKeyWord?.toLowerCase())) || isEmpty(searchedKeyWord)) {
          view === "card"
            ? result.push(
                <Card
                  key={report.value}
                  type={report.type}
                  handleClick={() => {
                    props.handleReportClick(report);
                    props.handleOpenFlagOfLeftNav();
                    //Clearing store data for CM matrix on selected report change by user
                    usePopulationInsightStore.getState().clearStore();
                    usePatientProfileStore.getState().clearStore();
                    useHospitalMappingStore.getState().clearStore();
                    useHighCostPatientStore.getState().clearStore();
                    useGenericTableStore.getState().clearStore();
                    useGlobalInformationStore.getState().clearStore();
                    useMeasuresStore.getState().clearStore();
                    useChronicBreakdownStore.getState().clearStore();
                    useDynamicFormStore.getState().clearStore();
                    useDataQualityReportStore.getState().clearStore();
                  }}
                  name={report.title}
                  lastUpdatedDate={report.lastUpdatedDate}
                  description={report.description}
                  starred={report.starred}
                  searchedKeyWord={searchedKeyWord}
                  reportValue={report.value}
                  updateReport={props.updateReport}
                />
              )
            : result.push(
                <List
                  type={report.type}
                  handleClick={() => {
                    props.handleReportClick(report);
                    props.handleOpenFlagOfLeftNav();
                    //Clearing store data for CM matrix on selected report change by user
                    usePopulationInsightStore.getState().clearStore();
                    usePatientProfileStore.getState().clearStore();
                    useHospitalMappingStore.getState().clearStore();
                    useHighCostPatientStore.getState().clearStore();
                    useGenericTableStore.getState().clearStore();
                    useGlobalInformationStore.getState().clearStore();
                    useMeasuresStore.getState().clearStore();
                    useChronicBreakdownStore.getState().clearStore();
                    useDataQualityReportStore.getState().clearStore();
                  }}
                  name={report.title}
                  lastUpdatedDate={report.lastUpdatedDate}
                  description={report.description}
                  starred={report.starred}
                  searchedKeyWord={searchedKeyWord}
                  reportValue={report.value}
                  updateReport={props.updateReport}
                />
              );
        }
      }
    );

    return result;
  };

  return (
    <div className="ui-dashboard-home">
      {!isLoading ? (
        <>
          {/* Left Side Navigation Starts from here */}
          <LeftNav />

          {/* Listing the reports on the right hand side */}
          <div className="ui-dashboard-home__content">
            <div className="ui-dashboard-home__content__heading">
              {/* heading  */}
              <div className="ui-dashboard-home__content__heading__title">{selectedNavigation.groupTitle}</div>

              {/* change view of the report list */}
              <Radio.Group
                options={viewTypeOptions}
                onChange={(e) => setView(e.target.value)}
                value={view}
                optionType="button"
                className="ui-dashboard-home__content__heading__view"
                size="large"
                style={{ height: "42px" }}
              />
            </div>

            {/* list of the reports */}
            <div className="ui-dashboard-home__content__cards custom-scroll-bar">
              {(isEmpty(reportList) || reportListComponent().length === 0) && (
                <DataNotFound message={
                  selectedNavigation?.groupTitle === "Recently Opened"
                      ? "No recently opened reports found."
                      : selectedNavigation?.groupTitle === "Starred"
                      ? "No starred reports found."
                      : "No Reports found as per the selected criteria."
                  }
                />
              )}
              {reportListComponent()}
            </div>
          </div>
        </>
      ) : (
        <Spin spinning={isLoading} indicator={<HealthemSpinner />}>
          <div className="ui-dashboard-header-navbar-loader">
            <div className="ui-dashboard-header-navbar-loader__select-box shimmerBG"></div>
            <div className="ui-dashboard-header-navbar-loader__select-box shimmerBG"></div>
            <div className="ui-dashboard-header-navbar-loader__select-box ui-dashboard-header-navbar-loader__large shimmerBG"></div>
          </div>
        </Spin>
      )}
    </div>
  );
};

export default DashboardNavigation;
